import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";
import { BottomNav } from "./bottom-nav";

export function RootLayout() {
  const location = useLocation();
  const mainRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = mainRef.current;
    if (el) {
      el.classList.remove("page-enter");
      // Force reflow
      void el.offsetWidth;
      el.classList.add("page-enter");
    }
  }, [location.pathname]);

  return (
    <>
      <header
        className="sticky top-0 z-[500] flex items-center gap-[10px] px-4 py-2"
        style={{
          background: "linear-gradient(135deg, #0F2E5A 0%, #1B4F9B 55%, #2E7BC4 100%)",
          boxShadow: "0 2px 16px rgba(15,46,90,0.3)",
          paddingTop: "calc(8px + env(safe-area-inset-top))",
        }}
      >
        <span className="font-serif text-white text-lg leading-none" style={{ textShadow: "0 1px 3px rgba(0,0,0,0.3)" }}>
          MedVisit
        </span>
        <div className="w-px h-[22px] bg-white/20 flex-shrink-0" />
        <span className="font-mono text-[0.58rem] text-white/55 uppercase tracking-widest">
          Pro
        </span>
        <span className="ml-auto font-mono text-[0.62rem] text-white/55">
          {new Date().toLocaleDateString("pt-PT", { weekday: "short", day: "numeric", month: "short" })}
        </span>
      </header>
      <main ref={mainRef}>
        <Outlet />
      </main>
      <BottomNav />
    </>
  );
}
